"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.73 5.82c-.23-.12-.41-.3-.54-.53-.13-.24-.19-.51-.19-.79 0-.43.12-.81.41-1.1.29-.28.67-.4 1.1-.4.27 0 .53.06.76.18.23.12.41.3.54.53.13.24.19.5.19.79 0 .42-.12.81-.41 1.09-.29.29-.67.41-1.1.41-.27 0-.52-.06-.76-.18zm5.22 7.86L18.39 18H20v2h-3.05l-1.04-3.11c-.47 2.59-2.91 4.49-5.71 4.05-2.08-.32-3.79-2.02-4.13-4.1-.45-2.78 1.39-5.22 3.93-5.74V9h-.59l-3 3L5 10.59l3-3c.38-.38.88-.59 1.41-.59H12c.55 0 1 .45 1 1v3.42c.87.41 1.5.91 1.98 1.58H16c.43 0 .81.28.95.68zM8 16c0 1.65 1.35 3 3 3s3-1.35 3-3c0-.74-.27-1.45-.76-2-.57-.64-1.39-1-2.24-1-1.65 0-3 1.35-3 3z"
  })];
};

exports.default = _default;